import { motion } from "framer-motion";
import { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

// Importing Images
import image1 from "../Assets/Gallery/1.jpg";
import image2 from "../Assets/Gallery/2.jpg";
import image3 from "../Assets/Gallery/3.jpg";
import image4 from "../Assets/Gallery/4.jpg";
import image5 from "../Assets/Gallery/5.jpg";
import image6 from "../Assets/Gallery/6.jpg";
import image7 from "../Assets/Gallery/7.jpg";
import image8 from "../Assets/Gallery/8.jpg";
import image9 from "../Assets/Gallery/9.jpg";
import image10 from "../Assets/Gallery/10.jpg";
import image11 from "../Assets/Gallery/11.jpg";
import image12 from "../Assets/Gallery/12.jpg";
import image13 from "../Assets/Gallery/13.jpg";
import image14 from "../Assets/Gallery/14.jpg";
import image15 from "../Assets/Gallery/15.jpg";
import image16 from "../Assets/Gallery/16.jpg";
import image17 from "../Assets/Gallery/17.jpg";
import image18 from "../Assets/Gallery/18.jpg";
import image19 from "../Assets/Gallery/19.jpg";
import image20 from "../Assets/Gallery/20.jpg";

// Importing Videos
import video1 from "../Assets/Gallery/video1.mp4";
import video2 from "../Assets/Gallery/video2.mp4";
import video3 from "../Assets/Gallery/video3.mp4";
import video4 from "../Assets/Gallery/video4.mp4";
import video5 from "../Assets/Gallery/video5.mp4";
import video6 from "../Assets/Gallery/video6.mp4";
import video7 from "../Assets/Gallery/video7.mp4";
import video8 from "../Assets/Gallery/video8.mp4";
import video9 from "../Assets/Gallery/video9.mp4";
import video10 from "../Assets/Gallery/video10.mp4";

const mediaItems = [
  { type: "image", src: image1 },
  { type: "image", src: image2 },
  { type: "video", src: video1 },
  { type: "image", src: image3 },
  { type: "image", src: image4 },
  { type: "video", src: video2 },
  { type: "image", src: image5 },
  { type: "image", src: image6 },
  { type: "video", src: video3 },
  { type: "image", src: image7 },
  { type: "image", src: image8 },
  { type: "video", src: video4 },
  { type: "image", src: image9 },
  { type: "image", src: image10 },
  { type: "video", src: video5 },
  { type: "image", src: image11 },
  { type: "image", src: image12 },
  { type: "video", src: video6 },
  { type: "image", src: image13 },
  { type: "image", src: image14 },
  { type: "video", src: video7 },
  { type: "image", src: image15 },
  { type: "image", src: image16 },
  { type: "video", src: video8 },
  { type: "image", src: image17 },
  { type: "image", src: image18 },
  { type: "video", src: video9 },
  { type: "image", src: image19 },
  { type: "image", src: image20 },
  { type: "video", src: video10 },
];

const Portfolio = () => {
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [selectedType, setSelectedType] = useState(null);

  return (
    <div>
      <Header />
      <div className="bg-[#0F2C3E] min-h-screen p-4 sm:p-6 md:p-8">
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="text-center text-white"
        >
          <h1 className="text-3xl sm:text-4xl font-bold">My Portfolio</h1>
          <p className="text-gray-300 mt-2">Explore my work in images & videos!</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
          className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 mt-8"
        >
          {mediaItems.map((item, index) => (
            <motion.div
              key={index}
              className="relative overflow-hidden rounded-lg cursor-pointer aspect-[4/3]"
              whileHover={{ scale: 1.05 }}
              onClick={() => {
                setSelectedMedia(item.src);
                setSelectedType(item.type);
              }}
            >
              {item.type === "image" ? (
                <img
                  src={item.src}
                  alt={`Media ${index}`}
                  className="w-full h-full object-cover rounded-lg shadow-lg"
                />
              ) : (
                <video
                  className="w-full h-full object-cover rounded-lg shadow-lg"
                  autoPlay
                  loop
                  muted
                  playsInline
                >
                  <source src={item.src} type="video/mp4" />
                </video>
              )}
            </motion.div>
          ))}
        </motion.div>

        {selectedMedia && (
          <motion.div
            className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-70 backdrop-blur-sm p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
            onClick={() => setSelectedMedia(null)}
          >
            {selectedType === "image" ? (
              <motion.img
                src={selectedMedia}
                alt="Selected"
                className="max-w-full max-h-full md:max-w-3xl md:max-h-screen rounded-lg shadow-lg"
                initial={{ scale: 0.8 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.3 }}
              />
            ) : (
              <motion.video
                controls
                autoPlay
                loop
                muted
                className="max-w-full max-h-full md:max-w-3xl md:max-h-screen rounded-lg shadow-lg"
                initial={{ scale: 0.8 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.3 }}
              >
                <source src={selectedMedia} type="video/mp4" />
              </motion.video>
            )}
          </motion.div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Portfolio;
